import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface JobList {
    itemIndex: number;
    jobId: number;
    eventJob: string;
    customer: string;
    siteAddress: string;
    minScheduleDateFormatted: string;
    amountFormatted: string;
    paid: boolean;
    isDirty: boolean;
}

const JobsRequiringPaymentData = (props: RouteComponentProps<{}>) => {
    const [loading, setLoading] = React.useState(true);
    const [searching, setSearching] = React.useState(false);
    const [jobs, setJobs] = React.useState<JobList[]>([]);
    const [jobIdSearch, setJobSearchId] = React.useState(0);
    const [siteAddressSearch, setSiteAddressSearch] = React.useState("");
    const [customerSearch, setCustomerSearch] = React.useState("");
    const [sortType, setSortType] = React.useState(0);
    const [sortDirection, setSortDirection] = React.useState(0);

    React.useEffect(() => {
        window.scrollTo(0, 0);

        getData(0,0);
    }, []);

    const getData = async (paySortType: number, sortDir: number) => {
        const token = await authService.getAccessToken();

        axios.get('api/Job/GetJobsRequiringPayment?PaymentSortType=' + paySortType + "&sortDirection=" + sortDir, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            var jobsReqPay = res.data;
            for (var i = 0; i < jobsReqPay.length; i++) {
                jobsReqPay[i].itemIndex = i;
            }

            setJobs(jobsReqPay);
            setLoading(false);
        });
    }

    const searchPaidJobs = () => {
        if (jobIdSearch > 0 || siteAddressSearch.length > 5 || customerSearch.length > 5) {
            setSearching(true);
            getPaidJobs();
        } else {
            toast.error("Please enter a Job Id or Site Address (> 5 chars) or a Customer (> 5 chars)");
        }
    }

    const getPaidJobs = async () => {
        const token = await authService.getAccessToken();

        axios.get("api/Job/GetPaidScheduledJobs?JobId=" + jobIdSearch + "&SiteAddress=" + siteAddressSearch + "&Customer=" + customerSearch + "&PaymentSortType=" + sortType + "&sortDirection=" + sortDirection, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            var paidJobs = res.data;
            for (var i = 0; i < paidJobs.length; i++) {
                paidJobs[i].itemIndex = i;
            }

            setJobs(paidJobs);
            setLoading(false);
            setSearching(false);
        });
    }

    const handleJobIdChange = (e: any) => {
        e.preventDefault();

        let value = e.target.value * 1;
        setJobSearchId(value);
        setCustomerSearch("");
        setSiteAddressSearch("");
    }

    const handleSiteAddrChange = (e: any) => {
        e.preventDefault();

        let value = e.target.value;
        setJobSearchId(0);
        setCustomerSearch("");
        setSiteAddressSearch(value);
    }

    const handleCustChange = (e: any) => {
        e.preventDefault();

        let value = e.target.value;
        setJobSearchId(0);
        setCustomerSearch(value);
        setSiteAddressSearch("");
    }

    const handleCellCheckboxChange = (e: any, itemIndex: number) => {
        var jobList = [...jobs];
        let job = jobList[itemIndex];
        let value = e.target.checked;

        job.paid = value;
        job.isDirty = true;

        setJobs(jobList);
    }

    //Sort Jobs
    const handleSort = (e: any, columnSorted: number, sortDir: number) => {
        e.preventDefault();

        if (sortType == columnSorted) {
            //change direction only
            setSortDirection(sortDir);
        } else {
            //sort new column ascending
            setSortType(columnSorted);
            setSortDirection(sortDir);
        }

        getData(columnSorted, sortDir);
    }

    //End Sort Jobs

    const resetSearch = () => {
        setSiteAddressSearch("");
        setCustomerSearch("");
        setJobSearchId(0);
        getData(sortType, sortDirection);
    }

    const save = (e: any) => {
        e.preventDefault();

        saveJobs();
    }

    const saveJobs = async () => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        let paidJobs = jobs.filter(j => j.isDirty);

        var savePaidJobs = {
            jobs: paidJobs,
            subId: user.sub
        };

        //get list of paid job ids
        var jobsPaidForEmail = paidJobs.filter(p => p.paid);

        //save
        if (paidJobs.length > 0) {
            axios.post('api/Job/SavePaidJobs', savePaidJobs, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            })
            .then(res => {
                if (res.data.isError) {
                    var errors = res.data.messages as any[];
                    errors.map(function (error: any) {
                        toast.error(error.content);
                    });
                } else {
                    
                    setJobSearchId(0);
                    setCustomerSearch("");
                    setSiteAddressSearch("");
                    if (jobsPaidForEmail.length > 0) {
                        var paidJobIds = jobsPaidForEmail.map(j => j.jobId);
                        emailPaidJobs(paidJobIds);
                    } else {
                        toast.success("Jobs have been updated to Paid");
                        getData(sortType, sortDirection);
                    }
                }
            })
            .catch(error => {
                toast.error(error.message);
            });
        } else {
            toast.error("Select one or more jobs that have been paid");
        }
        
    }

    const emailPaidJobs = async (jobIds: number[]) => {
        //api/Job/EmailPaidJobs
        const token = await authService.getAccessToken();

        var emailPaidJobs = {
            jobIds: jobIds
        };

        axios.post('api/Job/EmailPaidJobs', emailPaidJobs, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            toast.success("Jobs have been updated to Paid");
            getData(sortType, sortDirection);
        })
        .catch(error => {
            toast.error("Jobs updated to paid, but there was an error while trying to email that the job has been released. Error: " + error.message);
        });
    } 

    const finalJobs = jobIdSearch != 0 ? jobs.filter(j => j.jobId === jobIdSearch) : siteAddressSearch != "" ? jobs.filter(j => j.siteAddress.toLowerCase().indexOf(siteAddressSearch.toLowerCase()) >= 0) : customerSearch != "" ? jobs.filter(j => j.customer.toLowerCase().indexOf(customerSearch.toLowerCase()) >= 0) : jobs;

    const renderDetails = (
        <div>
            <div className="makeitred">Note: when searching by Dash Job Id, you will need to enter the whole Job Id for it to find the job.</div>
            <div className="makeitflex">
                <label className="input-group--inline" htmlFor="jobIdSearch">
                    <span className="label label--setsizesm">Job Id</span>
                    <input className="input schedulenew__addSearch--width-lg" type="text" id="jobIdSearch" name="jobIdSearch" value={jobIdSearch} onChange={(e) => handleJobIdChange(e)}></input>
                </label>
                <label className="input-group--inline" htmlFor="customerSearch">
                    <span className="label label--setsizesm">Customer</span>
                    <input className="input schedulenew__addSearch--width-lg" type="text" id="customerSearch" name="customerSearch" value={customerSearch} onChange={(e) => handleCustChange(e)}></input>
                </label>
                <label className="input-group--inline" htmlFor="siteAddressSearch">
                    <span className="label label--setsizesm">Site Address</span>
                    <input className="input schedulenew__addSearch--width-lg" type="text" id="siteAddressSearch" name="siteAddressSearch" value={siteAddressSearch} onChange={(e) => handleSiteAddrChange(e)}></input>
                </label>

                <button className="defaultbutton defaultbutton__small allocate__searchMargin" type='button' onClick={(e) => resetSearch()}>Reset</button>
                <button className="defaultbutton defaultbutton__large allocate__searchMargin marginLeft10" type="button" onClick={searchPaidJobs} disabled={searching}>Search Paid Jobs</button>
                <span className={searching ? "alignitemscentre marginLeft10" : "hidden"}>Searching Paid Jobs...</span>
            </div>

            <div className='overflowAuto'>
                <table className='table tableColours'>
                    <thead>
                        <tr>
                            <th>Job Id
                                <i className={sortType === 2 && sortDirection === 1 ? "marginLeft10 fa-solid fa-circle-up" : "hidden"} title="Sort Descending" onClick={(e) => handleSort(e, 2, 2)}></i>
                                <i className={(sortType === 2 && sortDirection === 2) || (sortType != 2) ? "marginLeft10 fa-solid fa-circle-down" : "hidden"} title="Sort Ascending" onClick={(e) => handleSort(e, 2, 1)}></i>
                            </th>
                            <th>Event</th>
                            <th>Customer
                                <i className={sortType === 1 && sortDirection === 1 ? "marginLeft10 fa-solid fa-circle-up" : "hidden"} title="Sort Descending" onClick={(e) => handleSort(e, 1, 2)}></i>
                                <i className={(sortType === 1 && sortDirection === 2) || (sortType != 1) ? "marginLeft10 fa-solid fa-circle-down" : "hidden"} title="Sort Ascending" onClick={(e) => handleSort(e, 1, 1)}></i>
                            </th>
                            <th>Site Address</th>
                            <th>Min Delivery Date
                                <i className={sortType === 4 && sortDirection === 1 ? "marginLeft10 fa-solid fa-circle-up" : "hidden"} title="Sort Descending" onClick={(e) => handleSort(e, 4, 2)}></i>
                                <i className={(sortType === 4 && sortDirection === 2) || (sortType != 4) ? "marginLeft10 fa-solid fa-circle-down" : "hidden"} title="Sort Ascending" onClick={(e) => handleSort(e, 4, 1)}></i>
                            </th>
                            <th className="textalignright">Amount
                                <i className={sortType === 3 && sortDirection === 1 ? "marginLeft10 fa-solid fa-circle-up" : "hidden"} title="Sort Descending" onClick={(e) => handleSort(e, 3, 2)}></i>
                                <i className={(sortType === 3 && sortDirection === 2) || (sortType != 3) ? "marginLeft10 fa-solid fa-circle-down" : "hidden"} title="Sort Ascending" onClick={(e) => handleSort(e, 3, 1)}></i>
                            </th>
                            <th className="textaligncenter">Paid</th>
                        </tr>
                    </thead>
                    <tbody>
                        {finalJobs.map((job, index) =>
                            <tr key={job.jobId}>
                                <td className="table__text--align">
                                    <Link to={'/job/' + job.jobId} target="_blank">{job.jobId}</Link>
                                </td>
                                <td className="table__text--align">{job.eventJob}</td>
                                <td className="table__text--align">{job.customer}</td>
                                <td className="table__text--align">{job.siteAddress}</td>
                                <td className="table__text--align">{job.minScheduleDateFormatted}</td>
                                <td className="table__text--align textalignright">{job.amountFormatted}</td>
                                <td className="table__text--align textaligncenter">
                                    <input type='checkbox' id="paid" name="paid" className='paid' checked={job.paid} onChange={(e) => handleCellCheckboxChange(e, job.itemIndex)}></input>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <div className="colAlignRight marginBottom10">
                <button className="defaultbutton defaultbutton__large" type="button" onClick={save}>Save</button>
            </div>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (
        <div>
            <h1>Jobs Requiring Payment</h1>
            {contents}
        </div>
    );
}

export default JobsRequiringPaymentData;
